<template>
    <v-card flat>
        <v-card-text>
            <v-container fluid>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-list two-line subheader>
                            <v-subheader inset>
                                <span>Documentos</span>
                                <span class="ml-2"
                                    v-html="`(Tamaño Max. ${(this.parametros.taMaxArchivo/this.numDividir)} MB)`"></span>
                                <v-text-field style="display: none;"
                                    :rules="_.size(listDocumento) > totalFiles ? requeridoRegla : []" />
                            </v-subheader>

                            <v-list-item v-for="item in listDocumento" :key="item.title">
                                <v-list-item-avatar>
                                    <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title v-text="item.title"></v-list-item-title>
                                    <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-row dense>
                                        <v-col cols="12" sm="4">
                                            <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon ripple v-on="on">
                                                        <v-icon :color="colors" @click="abrirVentana(item.name)"
                                                            v-html="icon_action"></v-icon>
                                                        <input type="file" :id="item.name" style="display: none;"
                                                            :ref="item.name" @change="obtenerFile" accept=".pdf" />
                                                    </v-btn>
                                                </template>
                                                <span>Subir Archivo</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col cols="12" sm="4" v-show="_.size(item.base) > 0">
                                            <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon ripple v-on="on">
                                                        <v-icon :color="colors" @click="ver(item)"
                                                            v-html="'visibility'"></v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Ver Archivo</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>

                <v-row dense >
                    <v-col cols="12">
                        <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="12" class="text-right">
                        <v-btn rounded outlined class="mr-1" @click="setData('obForm.obDocumentos',listDocumento);setData('step',1)">Anterior</v-btn>
                        <v-btn rounded color="primary" @click="validar">Siguiente</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'StepperDocumentosComponent',
        components:{
            modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
        },
        inject:['setData'],
        props:{
            load:{
                type:Boolean,
                default: false
            },
            obModal:{
                type:Object,
                default: {}
            },
            listDocumento:{
                type:Object,
                default: {}
            },
            parametros:{
                type:Object,
                default:{}
            }
        },
        data: () => ({
            objPdf:{
                mostrar: false,
                base64: '',
                titulo: ''
            },
            numDividir: 1000000,
            totalFiles: 0,
            icon_action: 'cloud_upload',
            colors: "grey lighten-1",
            listFile:[
                {
                    idDocumento:'pt1',
                    documento:'Caratula de Póliza',
                    nombreArchivo:`${_.camelCase('Caratula de Póliza')}.pdf`
                },
                {
                    idDocumento:'pt2',
                    documento:'Condiciones Generales',
                    nombreArchivo:`${_.camelCase('Condiciones Generales')}.pdf`
                },
                {
                    idDocumento:'pt3',
                    documento:'Condiciones Particulares',
                    nombreArchivo:`${_.camelCase('Condiciones Particulares')}.pdf`
                },
                {
                    idDocumento:'pt4',
                    documento:'Formulario PLA',
                    nombreArchivo:`${_.camelCase('Formulario PLA')}.pdf`
                },
                {
                    documento:'Listado',
                    idDocumento:'pt5',
                    nombreArchivo:`${_.camelCase('Listado')}.pdf`
                }
            ]
        }),
        watch:{
            load(val){
                if (val && _.size(this.listDocumento) == 0) {
                    this.onListarCatalogoDocumentos('L');
                }
            }
        },
        methods:{
            onListarCatalogoDocumentos(event){
                if(!_.isUndefined(event)){
                    this.totalFiles = 0;
                    var lista = {};

                    _.forEach((this.listFile), (v,k) =>{
                        var id = _.camelCase(v['documento']);

                        _.set(lista,id,{
                            'id'                : v['idDocumento'],
                            'name'              : id,
                            'title'             : v['documento'] ,
                            'nameFile'          : v['nombreArchivo'],
                            'subtitle'          : v['nombreArchivo'],
                            'new'               : true,
                            'icon'              : 'folder',
                            'base'              : '',
                            'iconClass'         : 'grey lighten-1 white--text'
                        });
                    });

                    if(!_.isUndefined(this.obModal.idCertificado) && !_.isNull(this.obModal.idCertificado)){
                        var error = 'E';
                        var o = {opcion:'LISTAR_DOC',obPrincipal:_.pick(this.obModal,['idCertificado','poliza'])};

                        axios.post(`${BASE_URI}administrador/poliza-tradicional/listar-documento`,o)
                            .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}

                                    _.forEach(r.data.data,(v)=>{
                                        var i = _.findKey(lista,{'id':_.get(_.split(v.id,'.'),'0','')});
                                        lista[i].base = v.base;
                                        lista[i].new = false;
                                        lista[i].subtitle  = `${i}.pdf`;
                                        lista[i].iconClass = 'indigo lighten-2 white--text';   
                                    });

                                    this.setData('obForm.obDocumentos',lista);
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,error);
                            });
                    }else
                        this.setData('obForm.obDocumentos',lista);
                }
            },
            validar(){
                try {
                    var l = _.size(_.filter(_.cloneDeep(this.listDocumento),(v)=>{ return _.size(v.base) > 0; }));
                    if(_.size(this.listDocumento) != l) throw mensajeEstandar.faltaArchivos;
                        this.setData('obForm.obDocumentos',this.listDocumento);
                        this.setData('step',3);
                } catch (e) {
                    mensajesAlerta(e,'I');
                }
            },
            ver(v){
                this.objPdf.base64 = JSON.parse(JSON.stringify(v.base));
                this.objPdf.titulo = _.startCase(v.nameFile);
                this.objPdf.mostrar = true;
            },
            abrirVentana (p) {
                this.$refs[p][0].click();
            },
            obtenerFile(e){
                try {
                    var obj = e.target;
                    if(obj.files.length == 0) throw mensajeEstandar.faltaArchivos;
                    if(obj.files[0].size > this.parametros.taMaxArchivo) throw mensajeEstandar.taMaximoArchivoPdf;

                        var lista = _.cloneDeep(this.listDocumento);

                        return new Promise((resolve,reject)=>{
                            var fr = new FileReader();

                            fr.readAsDataURL(obj.files[0]);
                            fr.addEventListener('load', () => {
                                lista[obj.id].base = fr.result;
                                this.$forceUpdate();
                            });

                            return resolve(true);
                        })
                        .then((r)=>{
                            if(!r) throw mensajeEstandar.taMaximoArchivoPdf;
                                lista[obj.id].subtitle  = obj.files[0].name;
                                lista[obj.id].new  = true;
                                lista[obj.id].iconClass = 'indigo lighten-2 white--text';   
                                this.setData('obForm.obDocumentos',lista);
                                ++this.totalFiles;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,'I');
                            --this.totalFiles;
                        })


                } catch (error) {
                    lista[obj.id].subtitle  = '';
                    lista[obj.id].new  = false;
                    lista[obj.id].iconClass = 'grey lighten-1 white--text';
                    this.setData('obForm.obDocumentos',lista);
                    mensajesAlerta(mensajeEstandar.taMaximoArchivoPdf,'I');
                    --this.totalFiles;
                }
            },
            cerrarModalPdf(){
                this.objPdf.mostrar =  false;
                this.objPdf.base64 = '';
            }
        },
        provide(){
            return{
                cerrarModalPdf: this.cerrarModalPdf
            }
        }
    }
</script>